module.exports = __webpack_public_path__ + "img/tu04.4ba8315e.jpg";